import axios from 'axios';

const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    window.location.href = '/login';
};

export const fetchGetData = async (uri, payload, headers = {}) => {
    try {
        const response = await axios.get(uri, {
            params: payload, // Use params for GET requests
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                ...headers, // Merge any additional headers
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        handleErrorResponse(error);
    }
};

export const fetchPostData = async (uri, payload, headers = {}) => {
    try {
        const response = await axios.post(uri, payload, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                ...headers,
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        handleErrorResponse(error);
    }
};

export const fetchFormData = async (uri, payload, headers = {}) => {
    try {
        const response = await axios.post(uri, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                ...headers,
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        handleErrorResponse(error);
    }
};

const handleErrorResponse = (error) => {
    if (error.response) {
        // Request made and server responded
        const {status} = error.response;
        if (status === 401 || status === 403) {
            alert(error.response.data.message);
            logout(); // Call logout if unauthorized or forbidden
        } else {
            console.error(`Error: ${status} - ${error.response.data}`);
            // Handle other statuses as needed
        }
    } else if (error.request) {
        // The request was made but no response was received
        console.error('Error: No response received from server.', error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error:', error.message);
    }
};
